var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"u-absolute u-z-50 u-inset-x-0 u-top-0 u-bg-white u-p-15p u-m-5 u-text-small u-text-center"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.t('Pages.StoreLocator.NoLocationsMessage'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }